import NotificationProvider from 'utils/NotificationProvider'
import SocketProvider from 'context/socket/SocketProvider'
import { fetchToken } from 'containers/Login/loginSlice'
import Notifications from 'containers/Notifications'
import { exportLogsInIos } from 'utils/nativeApp'
import AppProvider from 'context/AppProvider'
import StoreManager from 'rest/storeManager'
import { Provider } from 'react-redux'
import { getConfig } from 'appSlice'
import * as process from 'process'
import ReactDOM from 'react-dom'
import View from 'layouts/View'
import Router from './Router'
import store from './store'
import React from 'react'
import Auth from './Auth'
import App from './App'
import './index.css'

/**
 * Fix for simple-peer package
 */
window.global = window;
window.process = process;

/**
 * Saving a store instance to a singleton
 */
StoreManager.set(store)
store.dispatch(getConfig())
store.dispatch(fetchToken())

/**
 * Logs for native ios app
 */
exportLogsInIos()

const app = <React.StrictMode>
  <Provider store={store}>
    <Auth>
      <SocketProvider>
        <App>
          <Router>
            <NotificationProvider>
              <AppProvider>
                <View />
                <Notifications />
              </AppProvider>
            </NotificationProvider>
          </Router>
        </App>
      </SocketProvider>
    </Auth>
  </Provider>
</React.StrictMode>

ReactDOM.render(app, document.getElementById('root'))
